export function TestModel(description = "", answerOfUser = "", isPassWriting = false) {
    this.description = description;
    this.answerOfUser = answerOfUser;
    this.isPassWriting = isPassWriting
}